import React from 'react';
import { Column, Copy, Row } from '@grubhubprod/gh-cookbook-react';
import { Stack, Square } from '@grubhubprod/gh-cookbook-react/dist';
import { RestrictionsList } from 'src/common/OrderRestrictions/RestrictionsList/RestrictionsList';
import { DinerNotificationPreferencesControl } from 'src/components/enterprise/features/Corporate/components/Form/DinerNotificationPreferences/DinerNotificationPreferencesControl';
import { useToggleRestrictions } from 'src/components/enterprise/features/Corporate/components/Form/common/hooks/useToggleRestrictions';
import { useGroupCheckboxValidate } from 'src/components/CookbookCheckboxWrapper/hooks/useGroupCheckboxValidate';
import {
  requiredRestrictionsValidator,
  GroupRestrictions,
} from 'src/common/OrderRestrictions/orderRestrictions.utils';

export type DinerNotificationPreferencesProps = {
  dinerNotificationPreferences: GroupRestrictions;
};

export function DinerNotificationPreferences({
  dinerNotificationPreferences,
}: DinerNotificationPreferencesProps): JSX.Element {
  const preferencesEnabled = useToggleRestrictions({
    restrictionsFieldName: 'dinerNotificationPreferences',
    toggleFieldName: 'enableDinerNotificationPreferences',
  });

  const { error, validate } = useGroupCheckboxValidate({
    optionKeys: (dinerNotificationPreferences?.[0]?.restrictions || []).map(
      (restriction) => restriction.type
    ),
    name: 'dinerNotificationPreferences',
    validateGroup: requiredRestrictionsValidator,
  });

  return (
    <>
      <Row gutter={12}>
        <Column phone={12} gutter={12}>
          <DinerNotificationPreferencesControl
            name="enableDinerNotificationPreferences"
            id="enableDinerNotificationPreferences"
          />
        </Column>
        {error && (
          <Column phone={12} gutter={12}>
            <Stack y="sm">
              <Copy variant="body" color="danger">
                {error.message}
              </Copy>
            </Stack>
          </Column>
        )}
      </Row>
      {preferencesEnabled && (
        <Square bg="white" inset="lg" dimension="2">
          <Row gutter={12}>
            <Column phone={12} gutter={12}>
              <Stack y="sm">
                <Copy variant="body">
                  Selecting any preference below will exclude those
                  communication types from being sent to employees of this
                  corporate account
                </Copy>
              </Stack>
            </Column>
          </Row>
          <Row gutter={12}>
            <Column phone={12} gutter={12}>
              <RestrictionsList
                groupedRestrictions={dinerNotificationPreferences}
                name="dinerNotificationPreferences"
                rules={{
                  validate,
                }}
              />
            </Column>
          </Row>
        </Square>
      )}
    </>
  );
}
